import { QUOTE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/quote_download_formats_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['quoteFormatsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
